var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//  @jsx h

import { toArray } from '@nrk/dh-utils';
import { h } from 'preact';
import PureComponent from '../lib/preact-pure-component';

var ViewportIntersections = function (_PureComponent) {
  _inherits(ViewportIntersections, _PureComponent);

  function ViewportIntersections(props) {
    _classCallCheck(this, ViewportIntersections);

    var _this = _possibleConstructorReturn(this, (ViewportIntersections.__proto__ || Object.getPrototypeOf(ViewportIntersections)).call(this));

    _this.state = {
      intersections: props.children.map(function (child, idx) {
        return {
          isIntersecting: false,
          ratio: null
        };
      })
    };
    return _this;
  }

  _createClass(ViewportIntersections, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          onEnter = _props.onEnter,
          onLeave = _props.onLeave,
          rootMargin = _props.rootMargin,
          threshold = _props.threshold,
          root = _props.root;

      var childNodes = toArray(this.elm.childNodes);

      this.intersectionObserver = new IntersectionObserver(function (entries) {
        var intersections = _this2.state.intersections.slice(0);

        entries.forEach(function (entry) {
          var idx = childNodes.indexOf(entry.target);
          var prevIntersection = intersections[idx];

          intersections.splice(idx, 1, {
            isIntersecting: entry.isIntersecting,
            ratio: entry.intersectionRatio
          });

          if (onEnter && !prevIntersection.isIntersecting && entry.isIntersecting) {
            onEnter(entry, idx);
          }

          if (onLeave && prevIntersection.isIntersecting && !entry.isIntersecting) {
            onLeave(entry, idx);
          }
        });

        _this2.setState({ intersections: intersections });

        if (onChange) {
          onChange(intersections);
        }
      }, {
        root: root === 'self' ? this.elm : root,
        rootMargin: rootMargin || '0px 0px 0px 0px',
        threshold: threshold || 1.0
      });

      childNodes.forEach(function (childElm) {
        return _this2.intersectionObserver.observe(childElm);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.intersectionObserver.disconnect();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          className = _props2.className,
          children = _props2.children,
          style = _props2.style;


      return h(
        'div',
        { ref: function ref(elm) {
            return _this3.elm = elm;
          }, className: className, style: style },
        children
      );
    }
  }]);

  return ViewportIntersections;
}(PureComponent);

export default ViewportIntersections;